import type { ConsentManagementTool } from '../model';
import type { ConsentManagementGetAttributes } from './types';

const resolveConsentManagementTool = (app: ConsentManagementGetAttributes): ConsentManagementTool | null => {
  if (!app.gdpr) {
    return null;
  }

  switch (app.cmp) {
    case 'cookie_information':
      return 'CookieInformationCMP';
    case 'piwik': {
      if (app.gdprUserModeEnabled) {
        return 'OtherConsentTool';
      }
      return 'PiwikLegacy';
    }
    case null:
      return 'OtherConsentTool';
    default:
      throw new Error(`Unexpected value for app's cmp: "${app.cmp}"`);
  }
};

export { resolveConsentManagementTool };
